module.exports = __webpack_public_path__ + "img/onboarding-success-person.cc91371c.svg";